var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97079 20.7321C9.6126 21.0903 9.6126 21.671 9.97079 22.0292C10.329 22.3874 10.9097 22.3874 11.2679 22.0292L16 17.2971L20.7321 22.0292C21.0903 22.3874 21.671 22.3874 22.0292 22.0292C22.3874 21.671 22.3874 21.0903 22.0292 20.7321L17.2971 16L22.0292 11.2679C22.3874 10.9097 22.3874 10.329 22.0292 9.97079C21.671 9.6126 21.0903 9.6126 20.7321 9.97079L16 14.7029L11.2679 9.97079C10.9097 9.6126 10.329 9.6126 9.97079 9.97079C9.6126 10.329 9.6126 10.9097 9.97079 11.2679L14.7029 16L9.97079 20.7321Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.1961b44bfe7f21038a5cb64cd7c1bb91.svg";
export { ForwardRef as ReactComponent };